import { offlineCatalogsRepository } from '../repositories/offlineCatalogs.repository';
import { OfflineCatalogTransformers } from '../transformers/OfflineDatabaseCatalog.transformers';
import { OfflinePaginatedParamsWithQuery } from './types/common.types';

export const catalogsRepositoryOfflineAdapters = {
  list: async ({ limit, skip, query }: OfflinePaginatedParamsWithQuery) => {
    const offlineCatalogsPage = await offlineCatalogsRepository.pageWithNameSearch({
      limit,
      skip,
      query,
    });
    const offlineCatalogs = offlineCatalogsPage.data;
    const onlineCatalogs = offlineCatalogs.map(OfflineCatalogTransformers.toOnlineCatalog);

    return {
      data: onlineCatalogs,
      count: offlineCatalogsPage.count,
    };
  },
};
